import { useMemo, useState, useEffect } from "react";

import { useBoolean } from "src/hooks/use-boolean";

export const useMyInterestInvite = (startQuiz: any) => {
    const skipAnimation = useBoolean(false)

    const [currentImage, setCurrentImage] = useState(
        '/assets/images/my-interests/invite-transition.png'
    );

    useEffect(() => {
        const timer = setTimeout(
            () => {
                setCurrentImage('/assets/images/my-interests/invite.png');
                skipAnimation.onTrue()
            },
            items.length * 1000 + 250
        );
        return () => clearTimeout(timer);
    }, []);

    const itemVariants = useMemo(() => ({
        hidden: { opacity: 0, y: 20 },
        visible: (i: any) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: skipAnimation.value ? 0 : i * 1,
                duration: skipAnimation.value ? 0 : 0.8,
            },
        }),
    }), [skipAnimation.value]);

    const items = [
        {
            icon: 'lucide:pizza',
            text: 'Receba sugestões de acordo com as suas preferências.',
        },
        {
            icon: 'lucide:sparkles',
            text: 'Escolha suas preferências em poucos cliques.',
        },
        {
            icon: 'lucide:book-heart',
            text: 'Sua tela inicial será personalizada com o que você mais gosta.',
        },
    ];

    const imageVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0.8 } },
    };

    const handleClickButton = () => {
        if (!skipAnimation.value) {
            skipAnimation.onTrue()
            setCurrentImage('/assets/images/my-interests/invite.png')
        } else if (skipAnimation.value) {
            startQuiz.onTrue()
        }
    }

    return {
        items,
        currentImage,
        itemVariants,
        imageVariants,
        skipAnimation,
        handleClickButton,
    }
};
